"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecaptchaToken = getRecaptchaToken;
exports.getSegmentAnalyticsSnipet = getSegmentAnalyticsSnipet;
exports.getSegmentAnalyticsInstance = getSegmentAnalyticsInstance;
exports.registerSegmentPageView = registerSegmentPageView;
exports.registerSegmentActivity = registerSegmentActivity;
exports.getSegmentAnonymousId = getSegmentAnonymousId;
exports.setOffMarketListingsSession = setOffMarketListingsSession;
exports.getOffMarketListingSession = getOffMarketListingSession;
exports.deleteOffMarketListingSession = deleteOffMarketListingSession;
exports.isOffMarketListingSessionActive = isOffMarketListingSessionActive;
exports.filterListings = filterListings;
exports.mergeCmsAndMLsRentals = mergeCmsAndMLsRentals;
function getRecaptchaToken(actionName) {
    return new Promise(function (resolve, reject) {
        var grecaptcha_ = typeof window !== "undefined" && window["grecaptcha"];
        if (grecaptcha_) {
            grecaptcha_.ready(function () {
                grecaptcha_
                    .execute(process.env.GOOGLE_RECAPTCHA_SITE_KEY, {
                    action: actionName,
                })
                    .then(function (token) {
                    resolve(token);
                });
            });
        }
        else {
            reject("Recaptcha not added to site");
        }
    });
}
function getSegmentAnalyticsSnipet() {
    var analitcsKey = process.env.GATSBY_SEGMENT_ANALYTICS_KEY;
    if (typeof window == "undefined" ||
        !analitcsKey ||
        analitcsKey.length === 0) {
        return null;
    }
    var url = typeof window !== "undefined" && window.location.pathname;
    return "!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error(\"Segment snippet included twice.\");else{analytics.invoked=!0;analytics.methods=[\"trackSubmit\",\"trackClick\",\"trackLink\",\"trackForm\",\"pageview\",\"identify\",\"reset\",\"group\",\"track\",\"ready\",\"alias\",\"debug\",\"page\",\"once\",\"off\",\"on\",\"addSourceMiddleware\",\"addIntegrationMiddleware\",\"setAnonymousId\",\"addDestinationMiddleware\"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement(\"script\");t.type=\"text/javascript\";t.async=!0;t.src=\"https://cdn.segment.com/analytics.js/v1/\" + key + \"/analytics.min.js\";var n=document.getElementsByTagName(\"script\")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};;analytics.SNIPPET_VERSION=\"4.16.1\";analytics.page(".concat(url ? "\"".concat(url, "\"") : "", ");}}();");
}
function getSegmentAnalyticsInstance() {
    var analytics = typeof window !== "undefined" && window["analytics"];
    return analytics;
}
function registerSegmentPageView() {
    var analytics = getSegmentAnalyticsInstance();
    analytics === null || analytics === void 0 ? void 0 : analytics.page();
}
function registerSegmentActivity(event, properties) {
    var analytics = getSegmentAnalyticsInstance();
    analytics === null || analytics === void 0 ? void 0 : analytics.track(event, properties);
}
function getSegmentAnonymousId() {
    var _a;
    var analytics = getSegmentAnalyticsInstance();
    return (_a = analytics === null || analytics === void 0 ? void 0 : analytics.user()) === null || _a === void 0 ? void 0 : _a.anonymousId();
}
function setOffMarketListingsSession() {
    var getCurrentTime = new Date().getTime();
    localStorage.setItem("offMarketSession", "".concat(getCurrentTime + 432000000));
}
function getOffMarketListingSession() {
    return localStorage.getItem("offMarketSession");
}
function deleteOffMarketListingSession() {
    return localStorage.removeItem("offMarketSession");
}
function isOffMarketListingSessionActive() {
    var getCurrentTime = new Date().getTime();
    var sessionExpiration = localStorage.getItem("offMarketSession");
    return getCurrentTime < Number(sessionExpiration);
}
function filterListings(listings, drupalListingFilter) {
    var exclusive = drupalListingFilter.exclusive, mLSIDs = drupalListingFilter.mLSIDs, majorAreas = drupalListingFilter.majorAreas, minorAreas = drupalListingFilter.minorAreas, cities = drupalListingFilter.cities, postalCodes = drupalListingFilter.postalCodes, types = drupalListingFilter.types, subTypes = drupalListingFilter.subTypes, subdivisions = drupalListingFilter.subdivisions, neighborhoods = drupalListingFilter.neighborhoods, counties = drupalListingFilter.counties, statuses = drupalListingFilter.statuses, officeMLSIDs = drupalListingFilter.officeMLSIDs, agentMLSIDs = drupalListingFilter.agentMLSIDs, features = drupalListingFilter.features, openHouse = drupalListingFilter.openHouse, hasVirtualTour = drupalListingFilter.hasVirtualTour, flags = drupalListingFilter.flags;
    if (exclusive && exclusive == "true") {
        listings = listings.filter(function (value) { return value.exclusive; });
    }
    if (mLSIDs && mLSIDs.length > 0) {
        var mlsidArray_1 = mLSIDs.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) { return mlsidArray_1.includes(value.mlsID); });
    }
    if (majorAreas && majorAreas.length > 0) {
        var majorAreasArray_1 = majorAreas.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) {
            return majorAreasArray_1.includes(value.majorArea);
        });
    }
    if (minorAreas && minorAreas.length > 0) {
        var minorAreasArray_1 = minorAreas.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) {
            return minorAreasArray_1.includes(value.minorArea);
        });
    }
    if (cities && cities.length > 0) {
        var citiesArray_1 = cities.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) { return value.address && citiesArray_1.includes(value.address.city); });
    }
    if (postalCodes && postalCodes.length > 0) {
        var postalCodesArray_1 = postalCodes.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) { return value.address && postalCodesArray_1.includes(value.address.postal); });
    }
    if (types && types.length > 0) {
        var typesArray_1 = types.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) { return typesArray_1.includes(value.type); });
    }
    if (subTypes && subTypes.length > 0) {
        var subTypesArray_1 = subTypes.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) { return subTypesArray_1.includes(value.subType); });
    }
    if (statuses && statuses.length > 0) {
        var statusesArray_1 = statuses.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) { return statusesArray_1.includes(value.status); });
    }
    if (counties && counties.length > 0) {
        var countiesArray_1 = counties.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) { return value.address && countiesArray_1.includes(value.address.county); });
    }
    if (subdivisions && subdivisions.length > 0) {
        var subdivisionsArray_1 = subdivisions.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) {
            return subdivisionsArray_1.includes(value.subdivision);
        });
    }
    if (neighborhoods && neighborhoods.length > 0) {
        var neighborhoodsArray_1 = neighborhoods.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) {
            return neighborhoodsArray_1.includes(value.neighborhood);
        });
    }
    if (officeMLSIDs && officeMLSIDs.length > 0) {
        var officeMLSIDsArray_1 = officeMLSIDs.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) {
            return value.office[0] && officeMLSIDsArray_1.includes(value.office[0].mlsID);
        });
    }
    if (agentMLSIDs && agentMLSIDs.length > 0) {
        var agentMLSIDsArray_1 = agentMLSIDs.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) { return value.agent[0] && agentMLSIDsArray_1.includes(value.agent[0].mlsID); });
    }
    if (features && features.length > 0) {
        var featuresArray_1 = features.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) { return featuresArray_1.includes(value.features); });
    }
    if (openHouse && openHouse == "true") {
        listings = listings.filter(function (value) { return value.hasOpenHouse; });
    }
    if (hasVirtualTour && hasVirtualTour == "true") {
        listings = listings.filter(function (value) { return value.hasVirtualTour; });
    }
    if (flags && flags.length > 0) {
        var flagsArray_1 = flags.split(",").map(function (str) { return str.trim(); });
        listings = listings.filter(function (value) { return flagsArray_1.includes(value.flags); });
    }
}
function mergeCmsAndMLsRentals(getNodesByType, createNode, createNodeId, createContentDigest, touchNode) {
    return __awaiter(this, void 0, void 0, function () {
        var cmsRentals, _i, cmsRentals_1, cmsRental, mlsRentals, _a, mlsRentals_1, mlsRental, mergeRentalListings, mergedMlsRentalsIds, mergeableCmsRentalNodes, unmergedCmsRentalNodes, unmergedMlsRentalNodes;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getNodesByType("CmsRental")];
                case 1:
                    cmsRentals = _b.sent();
                    _i = 0, cmsRentals_1 = cmsRentals;
                    _b.label = 2;
                case 2:
                    if (!(_i < cmsRentals_1.length)) return [3 /*break*/, 5];
                    cmsRental = cmsRentals_1[_i];
                    return [4 /*yield*/, touchNode(cmsRental)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5: return [4 /*yield*/, getNodesByType("MlsRental")];
                case 6:
                    mlsRentals = _b.sent();
                    _a = 0, mlsRentals_1 = mlsRentals;
                    _b.label = 7;
                case 7:
                    if (!(_a < mlsRentals_1.length)) return [3 /*break*/, 10];
                    mlsRental = mlsRentals_1[_a];
                    return [4 /*yield*/, touchNode(mlsRental)];
                case 8:
                    _b.sent();
                    _b.label = 9;
                case 9:
                    _a++;
                    return [3 /*break*/, 7];
                case 10:
                    mergeRentalListings = function (cmsRental, mlsRental) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
                        var resultingListing = {
                            cmsID: cmsRental.cmsID,
                            mlsID: cmsRental.mlsID,
                            path: (_a = cmsRental.path) !== null && _a !== void 0 ? _a : mlsRental.path,
                            address: (_b = cmsRental.address) !== null && _b !== void 0 ? _b : mlsRental.address,
                            features: (_c = cmsRental.features) !== null && _c !== void 0 ? _c : mlsRental.features,
                            subdivision: (_d = cmsRental.subdivision) !== null && _d !== void 0 ? _d : mlsRental.subdivision,
                            type: cmsRental.type,
                            beds: (_e = cmsRental.beds) !== null && _e !== void 0 ? _e : mlsRental.beds,
                            baths: (_f = cmsRental.baths) !== null && _f !== void 0 ? _f : mlsRental.baths,
                            sleeps: (_g = cmsRental.sleeps) !== null && _g !== void 0 ? _g : mlsRental.sleeps,
                            bathsHalf: (_h = cmsRental.bathsHalf) !== null && _h !== void 0 ? _h : mlsRental.bathsHalf,
                            descriptionHTML: (_j = cmsRental.descriptionHTML) !== null && _j !== void 0 ? _j : mlsRental.descriptionHTML,
                            images: cmsRental.images && cmsRental.images.length > 0
                                ? cmsRental.images
                                : mlsRental.images,
                            defaultImage: (_k = cmsRental.defaultImage) !== null && _k !== void 0 ? _k : mlsRental.defaultImage,
                            details: (_l = cmsRental.details) !== null && _l !== void 0 ? _l : mlsRental.details,
                            location: (_m = cmsRental.location) !== null && _m !== void 0 ? _m : mlsRental.location,
                            cleaningFee: (_o = cmsRental.cleaningFee) !== null && _o !== void 0 ? _o : mlsRental.cleaningFee,
                            damageSecurityDeposit: (_p = cmsRental.damageSecurityDeposit) !== null && _p !== void 0 ? _p : mlsRental.damageSecurityDeposit,
                            seasonality: (_q = cmsRental.seasonality) !== null && _q !== void 0 ? _q : mlsRental.seasonality,
                            winterComments: cmsRental.winterComments,
                            ownerPolicies: (_r = cmsRental.ownerPolicies) !== null && _r !== void 0 ? _r : mlsRental.ownerPolicies,
                            salesTaxApplies: (_s = cmsRental.salesTaxApplies) !== null && _s !== void 0 ? _s : mlsRental.salesTaxApplies,
                            price: mlsRental.price,
                            rates: (_t = cmsRental.rates) !== null && _t !== void 0 ? _t : mlsRental.rates,
                            bookings: (_u = cmsRental.bookings) !== null && _u !== void 0 ? _u : [],
                            checkInTime: cmsRental.checkInTime,
                            checkOutTime: cmsRental.checkOutTime,
                            additionalLodgingFees: cmsRental.additionalLodgingFees,
                            officeName: mlsRental.officeName,
                            exclusive: mlsRental.exclusive,
                        };
                        return resultingListing;
                    };
                    mergedMlsRentalsIds = [];
                    mergeableCmsRentalNodes = cmsRentals.filter(function (rental) { return rental.mlsID; });
                    mergeableCmsRentalNodes.forEach(function (cmsRental) {
                        var rentalNode = cmsRental;
                        var mlsRental = mlsRentals.find(function (mlsRental) { return mlsRental.mlsID === cmsRental.mlsID; });
                        if (mlsRental) {
                            rentalNode = mergeRentalListings(cmsRental, mlsRental);
                            mergedMlsRentalsIds.push(mlsRental.mlsID);
                        }
                        createNode(__assign(__assign({}, rentalNode), { id: createNodeId("Rental-".concat(rentalNode.address.text)), internal: {
                                type: "Rental",
                                contentDigest: createContentDigest(rentalNode),
                            } }));
                    });
                    unmergedCmsRentalNodes = cmsRentals.filter(function (rental) { return !rental.mlsID; });
                    unmergedCmsRentalNodes.forEach(function (rentalNode) {
                        createNode(__assign(__assign({}, rentalNode), { id: createNodeId("Rental-".concat(rentalNode.address.text)), internal: {
                                type: "Rental",
                                contentDigest: createContentDigest(rentalNode),
                            } }));
                    });
                    unmergedMlsRentalNodes = mlsRentals.filter(function (rental) { return !mergedMlsRentalsIds.includes(rental.mlsID); });
                    unmergedMlsRentalNodes.forEach(function (rentalNode) {
                        createNode(__assign(__assign({}, rentalNode), { id: createNodeId("Rental-".concat(rentalNode.address.text)), internal: {
                                type: "Rental",
                                contentDigest: createContentDigest(rentalNode),
                            } }));
                    });
                    return [2 /*return*/];
            }
        });
    });
}
